import { createSelector } from 'reselect';

const getAppState = (store) => store.appState;
const appStateSelectorInputs = [getAppState];
const appStateSelectorFunc = (appState) => (appState ? appState : {});

export const selectAppState = createSelector(
  appStateSelectorInputs,
  appStateSelectorFunc
);

const getLoggedInUser = (store) => selectAppState(store).loggedInUser;
const loggedInUserSelectorInputs = [getLoggedInUser];
const loggedInUserSelectorFunc = (user) => (user ? user : {});

export const selectAppStateLoggedInUser = createSelector(
  loggedInUserSelectorInputs,
  loggedInUserSelectorFunc
);

const getLoggedInUserId = (store) =>
  store.appState.loggedInUser ? Number(store.appState.loggedInUser.id) : null;
const loggedInUserIdInputs = [getLoggedInUserId];
const loggedInUserIdFunc = (id) => (id ? id : null);

export const selectAppStateLoggedInUserId = createSelector(
  loggedInUserIdInputs,
  loggedInUserIdFunc
);

const getApiUrl = (store) => (store.appState ? store.appState.apiUrl : '');
const apiUrlInputs = [getApiUrl];
const apiUrlFunc = (url) => (url ? url : process.env.REACT_APP_API_URL);

export const selectAppStateApiUrl = createSelector(apiUrlInputs, apiUrlFunc);
